import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field, Form } from 'react-final-form';
import { Col } from 'react-bootstrap';
import {
  Card, CardBody,
} from '@/shared/components/Card';
import {
  FormButtonToolbar,
  FormContainer,
  FormGroup,
  FormGroupField,
  FormGroupLabel,
  FormHalfContainer,
} from '@/shared/components/form/FormElements';
import { renderMaskedField } from '@/shared/components/form/FormField';
import { Button } from '@/shared/components/Button';

const AddUpperLimit = ({ onSubmit, text }) => (
  <Col md={12} lg={12}>
    <Card>
      <CardBody>
        <Form onSubmit={onSubmit} horizantal>
          {({ handleSubmit }) => (
            <FormContainer onSubmit={handleSubmit}>
              <FormGroup>
                <FormGroupLabel>
                  Add Upper Credit Limit
                  <span style={{ color: 'red' }}>*</span>
                </FormGroupLabel>
                <FormGroupField>
                  <Field
                    name="limit"
                    component="input"
                    type="number"
                    placeholder="Enter Upper Credit Limit"
                    required
                  />
                </FormGroupField>
              </FormGroup>
              <FormButtonToolbar>
                <Button variant="success" type="submit">Confirm Agent</Button>
              </FormButtonToolbar>
            </FormContainer>
            )}
        </Form>
      </CardBody>
    </Card>
  </Col>
  );

  AddUpperLimit.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};

export default AddUpperLimit;
